import React from "react";
import { Component } from "react";
import { TextArea } from "../../../../custom-form/custom-textarea.component";
import ButtonIcon from "../../../../../button";
import InvoiceHistory from "./invoice-history.component";
import Icons from "../../../../../icon";
import { NotificationModal } from "../../../../modal/notification-modal.component";
import { Allowed_Extension, Conf_Message_Allowed_Extension } from "../../../../../../constants/external-constants";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryCircuitActions } from "../../../../../../store/external/reports-reducer/inventory/circuit.reducer"
import { getInventoryCircuit } from "../../../../../../constants/model-reducers/external/reports/inventory/circuit.settings";
class InvoiceComment extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            inputValue: "",
            fileList: [],
            showModal: false,
            modalMessage: ""
        }
    }
    handleConfirmationModal = () => {
        this.setState(prevState => ({ showModal: !prevState.showModal }));
    }
    componentDidMount() {
        const { getInventoryCircuitComments, inventoryCircuitFormA } = this.props;
        getInventoryCircuitComments(inventoryCircuitFormA.circuitID);
    }
    handleFileChange = (event) => {
        const file = event.target.files[0];
        const filename = file.name;
        const extIndex = filename.lastIndexOf('.');
        const newName = filename.substring(0, Math.min(extIndex, 20));
        const extension = filename.substring(extIndex + 1);
        const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;
        const allowedExtensions = Allowed_Extension;
        const modalMessageExt = Conf_Message_Allowed_Extension; 
        if (file.size <= 10 * 1024 * 1024) {
            if (this.state.fileList.length <= 2) {
                if (allowedExtensions.includes(extension)) {
                    this.setState({
                        selectedFile: file,
                        uploadedFileName: finalName,
                        fileList: [...this.state.fileList, finalName]
                    });
                } else {
                    this.setState({
                        showModal: true,
                        modalMessage: `Only files with the following format are allowed: ${modalMessageExt.map((ext) => ext + " ")}`
                    });
                }
            } else {
                this.setState({
                    showModal: true,
                    modalMessage: "Number of files exceeds the allowable limit of 3"
                });
            }
        } else {
            this.setState({
                showModal: true,
                modalMessage: "Total file size exceeds the allowable limit of 10 MB"
            });
        }
    };

    handleDeleteHeaderFile = (index) => {
        this.setState((prevState) => {
            const copyFileList = prevState.fileList.slice();
            copyFileList.splice(index, 1)
            return {
                fileList: copyFileList
            }
        })
    }
    postComment() {
        const { postInventoryCircuitComments, getInventoryCircuitComments, inventoryCircuitFormA } = this.props;
        postInventoryCircuitComments(inventoryCircuitFormA.circuitID, this.state.fileList, this.state.inputValue);
        getInventoryCircuitComments(inventoryCircuitFormA.circuitID);
    }
    render() {
        const { inventoryCircuitComments } = this.props.inventoryCircuit;
        return (
            <div className="invoice-comment-container">
                <div className="">
                    <div className="file-details-container">
                        <ul className="file-list-container">
                            {this.state.fileList.map((file, index) => (
                                <li className="file-list-item" key={index}>
                                    <div className="file-with-icon-container">
                                        <Icons
                                            customClassName="icon-file-clip"
                                            name="paper-clip-solid"
                                            size="15px"
                                            containerClass="icon-paper-clip-file-container"
                                        />
                                        {file}
                                    </div>
                                    <span className="delete-files-icon" onClick={() => this.handleDeleteHeaderFile(index)}>x</span>
                                </li>
                            ))}
                        </ul>
                        <TextArea customClass="invoice-comment-text" label="Comment" inputValue={this.state.inputValue} onChange={(e) => this.setState({ inputValue: e.target.value })} />
                    </div>
                    <div className="invoice-comment-button-container">
                        <ButtonIcon onClick={() => this.fileRef.current.click()} iconLeft="paper-clip-light" iconSize="17px" customClassName="header-filter-button" labelName="Attach File">
                            <input className="upload-file-btn" type="file" ref={this.fileRef} onChange={this.handleFileChange} />
                        </ButtonIcon>
                        <ButtonIcon onClick={() => this.postComment()} customClassName="header-filter-button" labelName="Post" />
                    </div>
                    < InvoiceHistory dataInfo={inventoryCircuitComments} noMessage={this.props.noMessage} />
                </div>
                <NotificationModal show={this.state.showModal} customClass="comment-notification-modal" handelModal={this.handleConfirmationModal} message={this.state.modalMessage} />
            </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuit } = state;
        const { inventoryCircuitFormA } = state.form;

        return {
            inventoryCircuit,
            inventoryCircuitFormA
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitActions),
        dispatch
    )
)(InvoiceComment);
